var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"data-icon":"credit-card-inverse","role":"img","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 11H4V8H20Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }